export default __webpack_public_path__ + "static/media/deszcz.d2a3f2da.svg";